/**
 * The board module's frontend manifest — everything it adds to the interface,
 * in one place. The backend half is `backend/src/modules/board/`.
 */
import CampaignOutlinedIcon from '@mui/icons-material/CampaignOutlined';
import { BOARD_PERMISSIONS } from '@forsys/shared';
import { defineFrontendModule } from '../types';
import BoardsPage from './BoardsPage';
import { DashboardBoards } from './DashboardBoards';

export const boardModule = defineFrontendModule({
  key: 'board',
  pages: [
    {
      path: 'boards',
      element: <BoardsPage />,
      anyOf: [BOARD_PERMISSIONS.UPDATE],
      nav: { section: 'content', labelKey: 'board:nav.boards', icon: CampaignOutlinedIcon },
    },
  ],
  slots: {
    // A session is enough: everybody sees their own groups' boards.
    'dashboard.sections': [{ id: 'boards', component: DashboardBoards }],
  },
});
